<template>
	<section class='beContent'>
		<div class='conhead'>
			<div class='conheadleft'>
				<img src="/static/dist/img/avatar.png" alt="" class='personPic'>
				<div>
					<h4>{{today.state}}好，{{teachName}}<span v-if='isPrincipal==1'>&nbsp;&nbsp;校长</span></h4>
					<p>祝你开心每一天</p>
				</div>
			</div>
			<ul class='conheadRight'>
				<li>
					<i-button type="error" @click='showItem(-1)'>添加应用</i-button>
				</li>
			<!-- 	<li>
					<img src="/static/dist/img/111.png" alt="" class='icon'>
					<div>
						<p>可使用应用</p>
						<h4>{{canUse}}</h4>
					</div>
				</li> -->
			</ul>
		</div>
		<section class='centerCon'>
			<div class='conterConItem' v-for='item in centerData' :key='item.title'>
				<h3 :id='item.ahref'>{{item.name}}</h3>
				<ul class='becard' :xs="24" :sm="24" :md="24" :lg="12">
					<!-- <router-link v-for='items in item.children' :to="items.url | filterUrl " :key='items.name'
						:name="items.url" tag='li'> -->
					<li v-for='items in item.children'  :key='items.guid'
						:name="items.url" tag='li' @click='showItem(items.guid,items)'>
						<img :src="items.logo" alt="" class='icon' v-if='items.logo'>
						<img src="/assets/img/hjzy.png" class='icon' alt="" v-else>
						<h5 v-if='items.url.indexOf("inchrouter")==-1'>{{items.name }}</h5>
						<h5 v-else class='orderFamily'>{{items.name }}<span class='ordering'>建设中</span></h5>
						<!-- <p>
							{{items.name}}<br>
							{{items.remark2}}
						</p> -->
					</li>
					<!-- </router-link> -->
				</ul>
			</div>
		</section>
		<bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
	</section>
</template>

<script>
	import utils from '../utils/getSchoolData.js'
	import letter from '../utils/letter.js'
	import bemodal from './formItemNoSch'
	export default {
		name: 'appcenter',
		components: {
			bemodal,
		},
		data() {
			return {

				teachName: '', // 当前登陆人姓名
				isPrincipal: 0, // 是否是校长
				schoolid: '',
				today: {
					week: '',
					date: '',
					state: '',
				},
				centerData: [],
				canUse: 0,
				selftitle: '编辑应用',
				cjType: '应用管理',
				smodal: false,
				reloadTmep: -1,
				initformData: [],
				formData: [
					['appCenterManager/getId.do', 'appCenterManager/save.do', 'appCenterManager/delete.do'],
					[{
							type: 'input',
							title: '应用名称',
							name: 'name',
							model: '',
							block: true
						},
						{
							type: 'selectApp',
							title: '所属类别',
							name: 'pid',
							model: '',
							chilrend:[],
							block: true
						},
						{
							type: 'input',
							title: '排序',
							name: 'sort',
							model: '',
							block: true
						},


						{
							type: 'input',
							title: '备注',
							name: 'remark',
							model: '',
							block: true
						},
						{
							type: 'input',
							title: 'URL',
							name: 'url',
							model: '',
							block: false
						},
						{
							type: 'uploadimg',
							title: 'LOGO',
							name: 'logo',
							model: '',
							pictype: {
								type: 'gallery',
                size:'156*156'
							},
							len: 1,
							block: true
						},
						{
							type: 'switch',
							title: '是否禁用',
							name: 'isdel',
							model: false,
							block: true
						},
            {
            	type: 'radio',
            	title: '身份认证',
            	name: 'lv',
            	model: 'LV0',
            	children:[
                {title:'LV0'},
                {title:'LV1'},
                {title:'LV2'}
              ]
            },
						{
							type: 'hidden',
							children: [{
								name: 'guid',
								model: ''
							}]
						}
					]
				],
				queryData: ['appCenterManager/getQueryList.do',
					[{
							title: '应用名称',
							key: 'appname',
							render: (h, params) => {

								return h('strong', params.row.appname)

							}
						},
						{
							title: '用途',
							key: '',
							align: 'center',
							render: (h, params) => {
								var c = params.row
								if (c.flag == '1') {
									return h('span', {
										style: {
											background: 'rgba(237,76,120,.1)',
											borderRadius: '7px',
											color: '#ed4c78',
											fontSize: '11px',
											padding: '4px 10px'
										},
									}, "教师端")
								} else if (c.flag == '2') {
									return h('span', {
										style: {
											background: 'rgba(0, 201, 219, 0.1)',
											borderRadius: '7px',
											color: 'rgb(0, 201, 219)',
											fontSize: '11px',
											padding: '4px 10px'
										},
									}, "家长端")
								} else if (c.flag == '3') {

									return h('div', [
										h('span', {
											style: {
												background: 'rgba(237,76,120,.1)',
												borderRadius: '7px',
												color: '#ed4c78',
												fontSize: '11px',
												padding: '4px 10px'
											},
										}, "教师端"),
										h('span', {
											style: {
												background: 'rgba(0, 201, 219, 0.1)',
												borderRadius: '7px',
												marginLeft: '6px',
												color: 'rgb(0, 201, 219)',
												fontSize: '11px',
												padding: '4px 10px'
											},
										}, "家长端")
									]);
								} else if (c.flag == '4') {
									return h('span', {
										style: {
											background: '#edfcf6',
											borderRadius: '7px',
											color: '#00d186',
											fontSize: '11px',
											padding: '4px 10px'
										},
									}, "屏显端")
								} else if (c.flag == '5') {
									return h('span', {
										style: {
											background: 'skyblue',
											borderRadius: '7px',
											color: '#fff',
											fontSize: '11px',
											padding: '4px 10px'
										},
									}, "PC")
								}
							}
						},
						{
							title: '排序',
							key: 'sort',
							align: 'center',
						},
						{
							title: '备注',
							key: 'remark',
							align: 'center',
						},
						{
							title: '添加人',
							key: 'addusername',
							align: 'center',
						},
						{
							title: '类别',
							key: 'tname',
							align: 'center',
						},
						{
							title: '操作',
							slot: 'action',
							width: 110,
							align: 'center'
						}

					]
				],
				searchParam: {
					appname: '',
				},
				issearch: -1,
				rootApp:[],
			}
		},
		mounted() {
			var inchUser = JSON.parse(localStorage.getItem('inchUserinfo'))
			this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
			this.teachName = inchUser['name']
			this.isPrincipal = inchUser['isPrincipal']
			this.schoolid = inchUser['schoolid']
			var that = this

			this.today.date = this.getCurDate()
			this.today.week = "星期" + "日一二三四五六".charAt(new Date().getDay())
			this.today.state = this.getTimeState()

			var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
			var hadloading = localStorage.getItem('loadingMenu') ? JSON.parse(localStorage.getItem('loadingMenu')) : false

			// if (!hadloading) {
				that.axios.get('appCenterManager/getQueryList', {
					params: {length:-1}
				}).then(res => {
					//console.log(res,'--------------------->')
					// that.canUse = res.data.length
					// res.data =res.data.filter(function(val,index){
					// 	return val['name'] != 1
					// })
					// that.formatenewMenu(res.data)

				})
			// } else {
			// 	that.formatenewMenu(hadloading)
			// 	that.canUse = hadloading.length
			// }
			this.getRootName()
		},
		methods: {
			getRootName(){
				var that = this
				that.axios.get('dic/getQueryList', {
					params: {length:-1,rootid:'appcenter'}
				}).then(res => {
					//console.log(res)
					that.rootApp = res.data
					that.axios.get('appCenterManager/getQueryList', {
						params: {length:-1}
					}).then(back => {
						//console.log(res,'--------------------->')
						// that.canUse = res.data.length
						// res.data =res.data.filter(function(val,index){
						// 	return val['name'] != 1
						// })
						// that.formatenewMenu(res.data)
						var backData = back.data.filter(function(val,index){
							return val['rootname']
						})
						that.formatenewMenu(backData)
					})

				})
			},
			showItem(guid, row) {
				// //console.log(guid, 'guid', this.formData[0][0])

				if (this.formData[0][0].indexOf('?') > -1) {
					this.formData[0][0] = this.formData[0][0].split('?')[0]
				}
				var _guid = guid == -1 ? -1 : row.guid
				this.formData[0][0] = this.formData[0][0] + '?id=' + _guid
				if (_guid == -1) {
					this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
				}
				//console.log(guid, this.formData[0][0], this.formData[1])
				this.reloadTmep = Math.random()

			},
			reloadTable() {
				this.getRootName()
				this.issearch = Math.random()
			},
			formatenewMenu(type) {
				//console.log(type)
				var newArr = []
				var arr = []
				var that = this
				for (var i = 0; i < type.length; i++) {
					// if (type[i]['remark'] && type[i]['remark'].indexOf('|') > -1) {
					if (type[i]['remark']) {
						type[i]['remark1'] = type[i]['remark'].split('|')[0]
						type[i]['remark2'] = type[i]['remark'].split('|')[1]
					}

					if (arr.indexOf(type[i]['rootname']) > -1) {

					} else {
						arr.push(type[i]['rootname'])
					}
				}
				for (var j = 0; j < arr.length; j++) {
					var letter = that.formateLetter(arr[j])
					var ahref = ''
					switch (arr[j]) {
						case '智慧食堂':
							ahref = 'zhstang'
							break
						case '智慧会务':
							ahref = 'zhhw'
							break
						default:
							ahref = letter[0].toLowerCase()
					}

					var obj = {
						name: arr[j],
						ahref: ahref,
						children: []
					}
					for (var k = 0; k < type.length; k++) {
						if (arr[j] == type[k]['rootname']) {
							obj['children'].push(type[k])
						}
					}
					newArr.push(obj)
				}

				//console.log(newArr)
				that.centerData = newArr

			},
			postMoreApp() {
				var centerData = this.centerData
				var that = this
				centerData.map(function(val, index) {
					var child = val['children']
					child.map(function(_val, indexs) {
						var param = {
							appname: _val['name'],
							flag: 5,
							sort: index + indexs,
							url: _val['url'],
							tname: val['name'],
							remark: _val['infoFir'] + '|' + _val['infoSec'],
							logo: '',
							schoolid: that.schoolid,
						}
						//console.log(param)
						return false;
						that.axios.post('appCenterManager/save.do', param).then(res => {
							//console.log(res)
						})
					})

				})



			},
			formateRoute(data, data2) {
				if (data2 != '' && data2 != []) {
					for (var j = 0; j < data2.length; j++) {
						var gradeList = data.filter(function(el) {
							return data2[j]["id"] == el["pid"]
						})
						if (gradeList.length > 0) {
							data2[j]["children"] = gradeList
						} else {
							data2[j]["children"] = []
						}

						this.formateRoute(data, gradeList)

					}


				} else {}
				return JSON.stringify(data2)
			},
			formateLetter(str) {
				// 汉字拼音首字母列表 本列表包含了20902个汉字,用于配合 ToChineseSpell
				//函数使用,本表收录的字符的Unicode编码范围为19968至40869, XDesigner 整理
				var strChineseFirstPY =
					"YDYQSXMWZSSXJBYMGCCZQPSSQBYCDSCDQLDYLYBSSJGYZZJJFKCCLZDHWDWZJLJPFYYNWJJTMYHZWZHFLZPPQHGSCYYYNJQYXXGJHHSDSJNKKTMOMLCRXYPSNQSECCQZGGLLYJLMYZZSECYKYYHQWJSSGGYXYZYJWWKDJHYCHMYXJTLXJYQBYXZLDWRDJRWYSRLDZJPCBZJJBRCFTLECZSTZFXXZHTRQHYBDLYCZSSYMMRFMYQZPWWJJYFCRWFDFZQPYDDWYXKYJAWJFFXYPSFTZYHHYZYSWCJYXSCLCXXWZZXNBGNNXBXLZSZSBSGPYSYZDHMDZBQBZCWDZZYYTZHBTSYYBZGNTNXQYWQSKBPHHLXGYBFMJEBJHHGQTJCYSXSTKZHLYCKGLYSMZXYALMELDCCXGZYRJXSDLTYZCQKCNNJWHJTZZCQLJSTSTBNXBTYXCEQXGKWJYFLZQLYHYXSPSFXLMPBYSXXXYDJCZYLLLSJXFHJXPJBTFFYABYXBHZZBJYZLWLCZGGBTSSMDTJZXPTHYQTGLJSCQFZKJZJQNLZWLSLHDZBWJNCJZYZSQQYCQYRZCJJWYBRTWPYFTWEXCSKDZCTBZHYZZYYJXZCFFZZMJYXXSDZZOTTBZLQWFCKSZSXFYRLNYJMBDTHJXSQQCCSBXYYTSYFBXDZTGBCNSLCYZZPSAZYZZSCJCSHZQYDXLBPJLLMQXTYDZXSQJTZPXLCGLQTZWJBHCTSYJSFXYEJJTLBGXSXJMYJQQPFZASYJNTYDJXKJCDJSZCBARTDCLYJQMWNQNCLLLKBYBZZSYHQQLTWLCCXTXLLZNTYLNEWYZYXCZXXGRKRMTCNDNJTSYYSSDQDGHSDBJGHRWRQLYBGLXHLGTGXBQJDZPYJSJYJCTMRNYMGRZJCZGJMZMGXMPRYXKJNYMSGMZJYMKMFXMLDTGFBHCJHKYLPFMDXLQJJSMTQGZSJLQDLDGJYCALCMZCSDJLLNXDJFFFFJCZFMZFFPFKHKGDPSXKTACJDHHZDDCRRCFQYJKQCCWJDXHWJLYLLZGCFCQDSMLZPBJJPLSBCJGGDCKKDEZSQCCKJGCGKDJTJDLZYCXKLQSCGJCLTFPCQCZGWPJDQYZJJBYJHSJDZWGFSJGZKQCCZLLPSPKJGQJHZZLJPLGJGJJTHJJYJZCZMLZLYQBGJWMLJKXZDZNJQSYZMLJLLJKYWXMKJLHSKJGBMCLYYMKXJQLBMLLKMDXXKWYXYSLMLPSJQQJQXYXFJTJDXMXXLLCXQBSYJBGWYMBGGBCYXPJYGPEPFGDJGBHBNSQJYZJKJKHXQFGQZKFHYGKHDKLLSDJQXPQYKYBNQSXQNSZSWHBSXWHXWBZZXDMNSJBSBKBBZKLYLXGWXDRWYQZMYWSJQLCJXXJXKJEQXSCYETLZHLYYYSDZPAQYZCMTLSHTZCFYZYXYLJSDCJQAGYSLCQLYYYSHMRQQKLDXZSCSSSYDYCJYSFSJBFRSSZQSBXXPXJYSDRCKGJLGDKZJZBDKTCSYQPYHSTCLDJDHMXMCGXYZHJDDTMHLTXZXYLYMOHYJCLTYFBQQXPFBDFHHTKSQHZYYWCNXXCRWHOWGYJLEGWDQCWGFJYCSNTMYTOLBYGWQWESJPWNMLRYDZSZTXYQPZGCWXHNGPYXSHMYQJXZTDPPBFYHZHTJYFDZWKGKZBLDNTSXHQEEGZZYLZMMZYJZGXZXKHKSTXNXXWYLYAPSTHXDWHZYMPXAGKYDXBHNHXKDPJNMYHYLPMGOCSLNZHKXXLPZZLBMLSFBHHGYGYYGGBHSCYAQTYWLXTZQCEZYDQDQMMHTKLLSZHLSJZWFYHQSWSCWLQAZYNYTLSXTHAZNKZZSZZLAXXZWWCTGQQTDDYZTCCHYQZFLXPSLZYGPZSZNGLNDQTBDLXGTCTAJDKYWNSYZLJHHZZCWNYYZYWMHYCHHYXHJKZWSXHZYXLYSKQYSPSLYZWMYPPKBYGLKZHTYXAXQSYSHXASMCHKDSCRSWJPWXSGZJLWWSCHSJHSQNHCSEGNDAQTBAALZZMSSTDQJCJKTSCJAXPLGGXHHGXXZCXPDMMHLDGTYBYSJMXHMRCPXXJZCKZXSHMLQXXTTHXWZFKHCCZDYTCJYXQHLXDHYPJQXYLSYYDZOZJNYXQEZYSQYAYXWYPDGXDDXSPPYZNDLTWRHXYDXZZJHTCXMCZLHPYYYYMHZLLHNXMYLLLMDCPPXHMXDKYCYRDLTXJCHHZZXZLCCLYLNZSHZJZZLNNRLWHYQSNJHXYNTTTKYJPYCHHYEGKCTTWLGQRLGGTGTYGYHPYHYLQYQGCWYQKPYYYTTTTLHYHLLTYTTSPLKYZXGZWGPYDSSZZDQXSKCQNMJJZZBXYQMJRTFFBTKHZKBXLJJKDXJTLBWFZPPTKQTZTGPDGNTPJYFALQMKGXBDCLZFHZCLLLLADPMXDJHLCCLGYHDZFGYDDGCYYFGYDXKSSEBDHYKDKDKHNAXXYBPBYYHXZQGAFFQYJXDMLJCSQZLLPCHBSXGJYNDYBYQSPZWJLZKSDDTACTBXZDYZYPJZQSJNKKTKNJDJGYYPGTLFYQKASDNTCYHBLWDZHBBYDWJRYGKZYHEYYFJMSDTYFZJJHGCXPLXHLDWXXJKYTCYKSSSMTWCTTQZLPBSZDZWZXGZAGYKTYWXLHLSPBCLLOQMMZSSLCMBJCSZZKYDCZJGQQDSMCYTZQQLWZQZXSSFPTTFQMDDZDSHDTDWFHTDYZJYQJQKYPBDJYYXTLJHDRQXXXHAYDHRJLKLYTWHLLRLLRCXYLBWSRSZZSYMKZZHHKYHXKSMDSYDYCJPBZBSQLFCXXXNXKXWYWSDZYQOGGQMMYHCDZTTFJYYBGSTTTYBYKJDHKYXBELHTYPJQNFXFDYKZHQKZBYJTZBXHFDXKDASWTAWAJLDYJSFHBLDNNTNQJTJNCHXFJSRFWHZFMDRYJYJWZPDJKZYJYMPCYZNYNXFBYTFYFWYGDBNZZZDNYTXZEMMQBSQEHXFZMBMFLZZSRXYMJGSXWZJSPRYDJSJGXHJJGLJJYNZZJXHGXKYMLPYYYCXYTWQZSWHWLYRJLPXSLSXMFSWWKLCTNXNYNPSJSZHDZEPTXMYYWXYYSYWLXJQZQXZDCLEEELMCPJPCLWBXSQHFWWTFFJTNQJHJQDXHWLBYZNFJLALKYYJLDXHHYCSTYYWNRJYXYWTRMDRQHWQCMFJDYZMHMYYXJWMYZQZXTLMRSPWWCHAQBXYGZYPXYYRRCLMPYMGKSJSZYSRMYJSNXTPLNBAPPYPYLXYYZKYNLDZYJZCZNNLMZHHARQMPGWQTZMXXMLLHGDZXYHXKYXYCJMFFYYHJFSBSSQLXXNDYCANNMTCJCYPRRNYTYQNYYMBMSXNDLYLYSLJRLXYSXQMLLYZLZJJJKYZZCSFBZXXMSTBJGNXYZHLXNMCWSCYZYFZLXBRNNNYLBNRTGZQYSATSWRYHYJZMZDHZGZDWYBSSCSKXSYHYTXXGCQGXZZSHYXJSCRHMKKBXCZJYJYMKQHZJFNBHMQHYSNJNZYBKNQMCLGQHWLZNZSWXKHLJHYYBQLBFCDSXDLDSPFZPSKJYZWZXZDDXJSMMEGJSCSSMGCLXXKYYYLNYPWWWGYDKZJGGGZGGSYCKNJWNJPCXBJJTQTJWDSSPJXZXNZXUMELPXFSXTLLXCLJXJJLJZXCTPSWXLYDHLYQRWHSYCSQYYBYAYWJJJQFWQCQQCJQGXALDBZZYJGKGXPLTZYFXJLTPADKYQHPMATLCPDCKBMTXYBHKLENXDLEEGQDYMSAWHZMLJTWYGXLYQZLJEEYYBQQFFNLYXRDSCTGJGXYYNKLLYQKCCTLHJLQMKKZGCYYGLLLJDZGYDHZWXPYSJBZKDZGYZZHYWYFQYTYZSZYEZZLYMHJJHTSMQWYZLKYYWZCSRKQYTLTDXWCTYJKLWSQZWBDCQYNCJSRSZJLKCDCDTLZZZACQQZZDDXYPLXZBQJYLZLLLQDDZQJYJYJZYXNYYYNYJXKXDAZWYRDLJYYYRJLXLLDYXJCYWYWNQCCLDDNYYYNYCKCZHXXCCLGZQJGKWPPCQQJYSBZZXYJSQPXJPZBSBDSFNSFPZXHDWZTDWPPTFLZZBZDMYYPQJRSDZSQZSQXBDGCPZSWDWCSQZGMDHZXMWWFYBPDGPHTMJTHZSMMBGZMBZJCFZWFZBBZMQCFMBDMCJXLGPNJBBXGYHYYJGPTZGZMQBQTCGYXJXLWZKYDPDYMGCFTPFXYZTZXDZXTGKMTYBBCLBJASKYTSSQYYMSZXFJEWLXLLSZBQJJJAKLYLXLYCCTSXMCWFKKKBSXLLLLJYXTYLTJYYTDPJHNHNNKBYQNFQYYZBYYESSESSGDYHFHWTCJBSDZZTFDMXHCNJZYMQWSRYJDZJQPDQBBSTJGGFBKJBXTGQHNGWJXJGDLLTHZHHYYYYYYSXWTYYYCCBDBPYPZYCCZYJPZYWCBDLFWZCWJDXXHYHLHWZZXJTCZLCDPXUJCZZZLYXJJTXPHFXWPYWXZPTDZZBDZCYHJHMLXBQXSBYLRDTGJRRCTTTHYTCZWMXFYTWWZCWJWXJYWCSKYBZSCCTZQNHXNWXXKHKFHTSWOCCJYBCMPZZYKBNNZPBZHHZDLSYDDYTYFJPXYNGFXBYQXCBHXCPSXTYZDMKYSNXSXLHKMZXLYHDHKWHXXSSKQYHHCJYXGLHZXCSNHEKDTGZXQYPKDHEXTYKCNYMYYYPKQYYYKXZLTHJQTBYQHXBMYHSQCKWWYLLHCYYLNNEQXQWMCFBDCCMLJGGXDQKTLXKGNQCDGZJWYJJLYHHQTTTNWCHMXCXWHWSZJYDJCCDBQCDGDNYXZTHCQRXCBHZTQCBXWGQWYYBXHMBYMYQTYEXMQKYAQYRGYZSLFYKKQHYSSQYSHJGJCNXKZYCXSBXYXHYYLSTYCXQTHYSMGSCPMMGCCCCCMTZTASMGQZJHKLOSQYLSWTMXSYQKDZLJQQYPLSYCZTCQQPBBQJZCLPKHQZYYXXDTDDTSJCXFFLLCHQXMJLWCJCXTSPYCXNDTJSHJWXDQQJSKXYAMYLSJHMLALYKXCYYDMNMDQMXMCZNNCYBZKKYFLMCHCMLHXRCJJHSYLNMTJZGZGYWJXSRXCWJGJQHQZDQJDCJJZKJKGDZQGJJYJYLXZXXCDQHHHEYTMHLFSBDJSYYSHFYSTCZQLPBDRFRZTZYKYWHSZYQKWDQZRKMSYNBCRXQBJYFAZPZZEDZCJYWBCJWHYJBQSZYWRYSZPTDKZPFPBNZTKLQYHBBZPNPPTYZZYBQNYDCPJMMCYCQMCYFZZDCMNLFPBPLNGQJTBTTNJZPZBBZNJKLJQYLNBZQHKSJZNGGQSZZKYXSHPZSNBCGZKDDZQANZHJKDRTLZLSWJLJZLYWTJNDJZJHXYAYNCBGTZCSSQMNJPJYTYSWXZFKWJQTKHTZPLBHSNJZSYZBWZZZZLSYLSBJHDWWQPSLMMFBJDWAQYZTCJTBNNWZXQXCDSLQGDSDPDZHJTQQPSWLYYJZLGYXYZLCTCBJTKTYCZJTQKBSJLGMGZDMCSGPYNJZYQYYKNXRPWSZXMTNCSZZYXYBYHYZAXYWQCJTLLCKJJTJHGDXDXYQYZZBYWDLWQCGLZGJGQRQZCZSSBCRPCSKYDZNXJSQGXSSJMYDNSTZTPBDLTKZWXQWQTZEXNQCZGWEZKSSBYBRTSSSLCCGBPSZQSZLCCGLLLZXHZQTHCZMQGYZQZNMCOCSZJMMZSQPJYGQLJYJPPLDXRGZYXCCSXHSHGTZNLZWZKJCXTCFCJXLBMQBCZZWPQDNHXLJCTHYZLGYLNLSZZPCXDSCQQHJQKSXZPBAJYEMSMJTZDXLCJYRYYNWJBNGZZTMJXLTBSLYRZPYLSSCNXPHLLHYLLQQZQLXYMRSYCXZLMMCZLTZSDWTJJLLNZGGQXPFSKYGYGHBFZPDKMWGHCXMSGDXJMCJZDYCABXJDLNBCDQYGSKYDQTXDJJYXMSZQAZDZFSLQXYJSJZYLBTXXWXQQZBJZUFBBLYLWDSLJHXJYZJWTDJCZFQZQZZDZSXZZQLZCDZFJHYSPYMPQZMLPPLFFXJJNZZYLSJEYQZFPFZKSYWJJJHRDJZZXTXXGLGHYDXCSKYSWMMZCWYBAZBJKSHFHJCXMHFQHYXXYZFTSJYZFXYXPZLCHMZMBXHZZSXYFYMNCWDABAZLXKTCSHHXKXJJZJSTHYGXSXYYHHHJWXKZXSSBZZWHHHCWTZZZPJXSNXQQJGZYZYWLLCWXZFXXYXYHXMKYYSWSQMNLNAYCYSPMJKHWCQHYLAJJMZXHMMCNZHBHXCLXTJPLTXYJHDYYLTTXFSZHYXXSJBJYAYRSMXYPLCKDUYHLXRLNLLSTYZYYQYGYHHSCCSMZCTZQXKYQFPYYRPFFLKQUNTSZLLZMWWTCQQYZWTLLMLMPWMBZSSTZRBPDDTLQJJBXZCSRZQQYGWCSXFWZLXCCRSZDZMCYGGDZQSGTJSWLJMYMMZYHFBJDGYXCCPSHXNZCSBSJYJGJMPPWAFFYFNXHYZXZYLREMZGZCYZSSZDLLJCSQFNXZKPTXZGXJJGFMYYYSNBTYLBNLHPFZDCYFBMGQRRSSSZXYSGTZRNYDZZCDGPJAFJFZKNZBLCZSZPSGCYCJSZLMLRSZBZZLDLSLLYSXSQZQLYXZLSKKBRXBRBZCYCXZZZEEYFGKLZLYYHGZSGZLFJHGTGWKRAAJYZKZQTSSHJJXDCYZUYJLZYRZDQQHGJZXSSZBYKJPBFRTJXLLFQWJHYLQTYMBLPZDXTZYGBDHZZRBGXHWNJTJXLKSCFSMWLSDQYSJTXKZSCFWJLBXFTZLLJZLLQBLSQMQQCGCZFPBPHZCZJLPYYGGDTGWDCFCZQYYYQYSSCLXZSKLZZZGFFCQNWGLHQYZJJCZLQZZYJPJZZBPDCCMHJGXDQDGDLZQMFGPSYTSDYFWWDJZJYSXYYCZCYHZWPBYKXRYLYBHKJKSFXTZJMMCKHLLTNYYMSYXYZPYJQYCSYCWMTJJKQYRHLLQXPSGTLYYCLJSCPXJYZFNMLRGJJTYZBXYZMSJYJHHFZQMSYXRSZCWTLRTQZSSTKXGQKGSPTGCZNJSJCQCXHMXGGZTQYDJKZDLBZSXJLHYQGGGTHQSZPYHJHHGYYGKGGCWJZZYLCZLXQSFTGZSLLLMLJSKCTBLLZZSZMMNYTPZSXQHJCJYQXYZXZQZCPSHKZZYSXCDFGMWQRLLQXRFZTLYSTCTMJCXJJXHJNXTNRZTZFQYHQGLLGCXSZSJDJLJCYDSJTLNYXHSZXCGJZYQPYLFHDJSBPCCZHJJJQZJQDYBSSLLCMYTTMQTBHJQNNYGKYRQYQMZGCJKPDCGMYZHQLLSLLCLMHOLZGDYYFZSLJCQZLYLZQJESHNYLLJXGJXLYSYYYXNBZLJSSZCQQCJYLLZLTJYLLZLLBNYLGQCHXYYXOXCXQKYJXXXYKLXSXXYQXCYKQXQCSGYXXYQXYGYTQOHXHXPYXXXULCYEYCHZZCBWQBBWJQZSCSZSSLZYLKDESJZWMYMCYTSDSXXSCJPQQSQYLYYZYCMDJDZYWCBTJSYDJKCYDDJLBDJJSODZYSYXQQYXDHHGQQYQHDYXWGMMMAJDYBBBPPBCMUUPLJZSMTXERXJMHQNUTPJDCBSSMSSSTKJTSSMMTRCPLZSZMLQDSDMJMQPNQDXCFYNBFSDQXYXHYAYKQYDDLQYYYSSZBYDSLNTFQTZQPZMCHDHCZCWFDXTMYQSPHQYYXSRGJCWTJTZZQMGWJJTJHTQJBBHWZPXXHYQFXXQYWYYHYSCDYDHHQMNMTMWCPBSZPPZZGLMZFOLLCFWHMMSJZTTDHZZYFFYTZZGZYSKYJXQYJZQBHMBZZLYGHGFMSHPZFZSNCLPBQSNJXZSLXXFPMTYJYGBXLLDLXPZJYZJYHHZCYWHJYLSJEXFSZZYWXKZJLUYDTMLYMQJPWXYHXSKTQJEZRPXXZHHMHWQPWQLYJJQJJZSZCPHJLCHHNXJLQWZJHBMZYXBDHHYPZLHLHLGFWLCHYYTLHJXCJMSCPXSTKPNHQXSRTYXXTESYJCTLSSLSTDLLLWWYHDHRJZSFGXTSYCZYNYHTDHWJSLHTZDQDJZXXQHGYLTZPHCSQFCLNJTCLZPFSTPDYNYLGMJLLYCQHYSSHCHYLHQYQTMZYPBYWRFQYKQSYSLZDQJMPXYYSSRHZJNYWTQDFZBWWTWWRXCWHGYHXMKMYYYQMSMZHNGCEPMLQQMTCWCTMMPXJPJJHFXYYZSXZHTYBMSTSYJTTQQQYYLHYNPYQZLCYZHZWSMYLKFJXLWGXYPJYTYSYXYMZCKTTWLKSMZSYLMPWLZWXWQZSSAQSYXYRHSSNTSRAPXCPWCMGDXHXZDZYFJHGZTTSBJHGYZSZYSMYCLLLXBTYXHBBZJKSSDMALXHYCFYGMQYPJYCQXJLLLJGSLZGQLYCJCCZOTYXMTMTTLLWTGPXYMZMKLPSZZZXHKQYSXCTYJZYHXSHYXZKXLZWPSQPYHJWPJPWXQQYLXSDHMRSLZZYZWTTCYXYSZZSHBSCCSTPLWSSCJCHNLCGCHSSPHYLHFHHXJSXYLLNYLSZDHZXYLSXLWZYKCLDYAXZCMDDYSPJTQJZLNWQPSSSWCTSTSZLBLNXSMNYYMJQBQHRZWTYYDCHQLXKPZWBGQYBKFCMZWPZLLYYLSZYDWHXPSBCMLJBSCGBHXLQHYRLJXYSWXWXZSLDFHLSLYNJLZYFLYJYCDRJLFSYZFSLLCQYQFGJYHYXZLYLMSTDJCYHBZLLNWLXXYGYYHSMGDHXXHHLZZJZXCZZZCYQZFNGWPYLCPKPYYPMCLQKDGXZGGWQBDXZZKZFBXXLZXJTPJPTTBYTSZZDWSLCHZHSLTYXHQLHYXXXYYZYSWTXZKHLXZXZPYHGCHKCFSYHUTJRLXFJXPTZTWHPLYXFCRHXSHXKYXXYHZQDXQWULHYHMJTBFLKHTXCWHJFWJCFPQRYQXCYYYQYGRPYWSGSUNGWCHKZDXYFLXXHJJBYZWTSXXNCYJJYMSWZJQRMHXZWFQSYLZJZGBHYNSLBGTTCSYBYXXWXYHXYYXNSQYXMQYWRGYQLXBBZLJSYLPSYTJZYHYZAWLRORJMKSCZJXXXYXCHDYXRYXXJDTSQFXLYLTSFFYXLMTYJMJUYYYXLTZCSXQZQHZXLYYXZHDNBRXXXJCTYHLBRLMBRLLAXKYLLLJLYXXLYCRYLCJTGJCMTLZLLCYZZPZPCYAWHJJFYBDYYZSMPCKZDQYQPBPCJPDCYZMDPBCYYDYCNNPLMTMLRMFMMGWYZBSJGYGSMZQQQZTXMKQWGXLLPJGZBQCDJJJFPKJKCXBLJMSWMDTQJXLDLPPBXCWRCQFBFQJCZAHZGMYKPHYYHZYKNDKZMBPJYXPXYHLFPNYYGXJDBKXNXHJMZJXSTRSTLDXSKZYSYBZXJLXYSLBZYSLHXJPFXPQNBYLLJQKYGZMCYZZYMCCSLCLHZFWFWYXZMWSXTYNXJHPYYMCYSPMHYSMYDYSHQYZCHMJJMZCAAGCFJBBHPLYZYLXXSDJGXDHKXXTXXNBHRMLYJSLTXMRHNLXQJXYZLLYSWQGDLBJHDCGJYQYCMHWFMJYBMBYJYJWYMDPWHXQLDYGPDFXXBCGJSPCKRSSYZJMSLBZZJFLJJJLGXZGYXYXLSZQYXBEXYXHGCXBPLDYHWETTWWCJMBTXCHXYQXLLXFLYXLLJLSSFWDPZSMYJCLMWYTCZPCHQEKCQBWLCQYDPLQPPQZQFJQDJHYMMCXTXDRMJWRHXCJZYLQXDYYNHYYHRSLSRSYWWZJYMTLTLLGTQCJZYABTCKZCJYCCQLJZQXALMZYHYWLWDXZXQDLLQSHGPJFJLJHJABCQZDJGTKHSSTCYJLPSWZLXZXRWGLDLZRLZXTGSLLLLZLYXXWGDZYGBDPHZPBRLWSXQBPFDWOFMWHLYPCBJCCLDMBZPBZZLCYQXLDOMZBLZWPDWYYGDSTTHCSQSCCRSSSYSLFYBFNTYJSZDFNDPDHDZZMBBLSLCMYFFGTJJQWFTMTPJWFNLBZCMMJTGBDZLQLPYFHYYMJYLSDCHDZJWJCCTLJCLDTLJJCPDDSQDSSZYBNDBJLGGJZXSXNLYCYBJXQYCBYLZCFZPPGKCXZDZFZTJJFJSJXZBNZYJQTTYJYHTYCZHYMDJXTTMPXSPLZCDWSLSHXYPZGTFMLCJTYCBPMGDKWYCYZCDSZZYHFLYCTYGWHKJYYLSJCXGYWJCBLLCSNDDBTZBSCLYZCZZSSQDLLMQYYHFSLQLLXFTYHABXGWNYWYYPLLSDLDLLBJCYXJZMLHLJDXYYQYTDLLLBUGBFDFBBQJZZMDPJHGCLGMJJPGAEHHBWCQXAXHHHZCHXYPHJAXHLPHJPGPZJQCQZGJJZZUZDMQYYBZZPHYHYBWHAZYJHYKFGDPFQSDLZMLJXKXGALXZDAGLMDGXMWZQYXXDXXPFDMMSSYMPFMDMMKXKSYZYSHDZKXSYSMMZZZMSYDNZZCZXFPLSTMZDNMXCKJMZTYYMZMZZMSXHHDCZJEMXXKLJSTLWLSQLYJZLLZJSSDPPMHNLZJCZYHMXXHGZCJMDHXTKGRMXFWMCGMWKDTKSXQMMMFZZYDKMSCLCMPCGMHSPXQPZDSSLCXKYXTWLWJYAHZJGZQMCSNXYYMMPMLKJXMHLMLQMXCTKZMJQYSZJSYSZHSYJZJCDAJZYBSDQJZGWZQQXFKDMSDJLFWEHKZQKJPEYPZYSZCDWYJFFMZZYLTTDZZEFMZLBNPPLPLPEPSZALLTYLKCKQZKGENQLWAGYXYDPXLHSXQQWQCQXQCLHYXXMLYCCWLYMQYSKGCHLCJNSZKPYZKCQZQLJPDMDZHLASXLBYDWQLWDNBQCRYDDZTJYBKBWSZDXDTNPJDTCTQDFXQQMGNXECLTTBKPWSLCTYQLPWYZZKLPYGZCQQPLLKCCYLPQMZCZQCLJSLQZDJXLDDHPZQDLJJXZQDXYZQKZLJCYQDYJPPYPQYKJYRMPCBYMCXKLLZLLFQPYLLLMBSGLCYSSLRSYSQTMXYXZQZFDZUYSYZTFFMZZSMZQHZSSCCMLYXWTPZGXZJGZGSJSGKDDHTQGGZLLBJDZLCBCHYXYZHZFYWXYZYMSDBZZYJGTSMTFXQYXQSTDGSLNXDLRYZZLRYYLXQHTXSRTZNGZXBNQQZFMYKMZJBZYMKBPNLYZPBLMCNQYZZZSJZHJCTZKHYZZJRDYZHNPXGLFZTLKGJTCTSSYLLGZRZBBQZZKLPKLCZYSSUYXBJFPNJZZXCDWXZYJXZZDJJKGGRSRJKMSMZJLSJYWQSKYHQJSXPJZZZLSNSHRNYPZTWCHKLPSRZLZXYJQXQKYSJYCZTLQZYBBYBWZPQDWWYZCYTJCJXCKCWDKKZXSGKDZXWWYYJQYYTCYTDLLXWKCZKKLCCLZCQQDZLQLCSFQCHQHSFSMQZZLNBJJZBSJHTSZDYSJQJPDLZCDCWJKJZZLPYCGMZWDJJBSJQZSYZYHHXJPBJYDSSXDZNCGLQMBTSFSBPDZDLZNFGFJGFSMPXJQLMBLGQCYYXBQKDJJQYRFKZTJDHCZKLBSDZCFJTPLLJGXHYXZCSSZZXSTJYGKGCKGYOQXJPLZPBPGTGYJZGHZQZZLBJLSQFZGKQQJZGYCZBZQTLDXRJXBSXXPZXHYZYCLWDXJJHXMFDZPFZHQHQMQGKSLYHTYCGFRZGNQXCLPDLBZCSCZQLLJBLHBZCYPZZPPDYMZZSGYHCKCPZJGSLJLNSCDSLDLXBMSTLDDFJMKDJDHZLZXLSZQPQPGJLLYBDSZGQLBZLSLKYYHZTTNTJYQTZZPSZQZTLLJTYYLLQLLQYZQLBDZLSLYYZYMDFSZSNHLXZNCZQZPBWSKRFBSYZMTHBLGJPMCZZLSTLXSHTCSYZLZBLFEQHLXFLCJLYLJQCBZLZJHHSSTBRMHXZHJZCLXFNBGXGTQJCZTMSFZKJMSSNXLJKBHSJXNTNLZDNTLMSJXGZJYJCZXYJYJWRWWQNZTNFJSZPZSHZJFYRDJSFSZJZBJFZQZZHZLXFYSBZQLZSGYFTZDCSZXZJBQMSZKJRHYJZCKMJKHCHGTXKXQGLXPXFXTRTYLXJXHDTSJXHJZJXZWZLCQSBTXWXGXTXXHXFTSDKFJHZYJFJXRZSDLLLTQSQQZQWZXSYQTWGWBZCGZLLYZBCLMQQTZHZXZXLJFRMYZFLXYSQXXJKXRMQDZDMMYYBSQBHGZMWFWXGMXLZPYYTGZYCCDXYZXYWGSYJYZNBHPZJSQSYXSXRTFYZGRHZTXSZZTHCBFCLSYXZLZQMZLMPLMXZJXSFLBYZMYQHXJSXRXSQZZZSSLYFRCZJRCRXHHZXQYDYHXSJJHZCXZBTYNSYSXJBQLPXZQPYMLXZKYXLXCJLCYSXXZZLXDLLLJJYHZXGYJWKJRWYHCPSGNRZLFZWFZZNSXGXFLZSXZZZBFCSYJDBRJKRDHHGXJLJJTGXJXXSTJTJXLYXQFCSGSWMSBCTLQZZWLZZKXJMLTMJYHSDDBXGZHDLBMYJFRZFSGCLYJBPMLYSMSXLSZJQQHJZFXGFQFQBPXZGYYQXGZTCQWYLTLGWSGWHRLFSFGZJMGMGBGTJFSYZZGZYZAFLSSPMLPFLCWBJZCLJJMZLPJJLYMQDMYYYFBGYGYZMLYZDXQYXRQQQHSYYYQXYLJTYXFSFSLLGNQCYHYCWFHCCCFXPYLYPLLZYXXXXXKQHHXSHJZCFZSCZJXCPZWHHHHHAPYLQALPQAFYHXDYLUKMZQGGGDDESRNNZLTZGCHYPPYSQJJHCLLJTOLNJPZLJLHYMHEYDYDSQYCDDHGZUNDZCLZYZLLZNTNYZGSLHSLPJJBDGWXPCDUTJCKLKCLWKLLCASSTKZZDNQNTTLYYZSSYSSZZRYLJQKCQDHHCRXRZYDGRGCWCGZQFFFPPJFZYNAKRGYWYQPQXXFKJTSZZXSWZDDFBBXTBGTZKZNPZZPZXZPJSZBMQHKCYXYLDKLJNYPKYGHGDZJXXEAHPNZKZTZCMXCXMMJXNKSZQNMNLWBWWXJKYHCPSTMCSQTZJYXTPCTPDTNNPGLLLZSJLSPBLPLQHDTNJNLYYRSZFFJFQWDPHZDWMRZCCLODAXNSSNYZRESTYJWJYJDBCFXNMWTTBYLWSTSZGYBLJPXGLBOCLHPCBJLTMXZLJYLZXCLTPNCLCKXTPZJSWCYXSFYSZDKNTLBYJCYJLLSTGQCBXRYZXBXKLYLHZLQZLNZCXWJZLJZJNCJHXMNZZGJZZXTZJXYCYYCXXJYYXJJXSSSJSTSSTTPPGQTCSXWZDCSYFPTFBFHFBBLZJCLZZDBXGCXLQPXKFZFLSYLTUWBMQJHSZBMDDBCYSCCLDXYCDDQLYJJWMQLLCSGLJJSYFPYYCCYLTJANTJJPWYCMMGQYYSXDXQMZHSZXPFTWWZQSWQRFKJLZJQQYFBRXJHHFWJJZYQAZMYFRHCYYBYQWLPEXCCZSTYRLTTDMQLYKMBBGMYYJPRKZNPBSXYXBHYZDJDNGHPMFSGMWFZMFQMMBCMZZCJJLCNUXYQLMLRYGQZCYXZLWJGCJCGGMCJNFYZZJHYCPRRCMTZQZXHFQGTJXCCJEAQCRJYHPLQLSZDJRBCQHQDYRHYLYXJSYMHZYDWLDFRYHBPYDTSSCNWBXGLPZMLZZTQSSCPJMXXYCSJYTYCGHYCJWYRXXLFEMWJNMKLLSWTXHYYYNCMMCWJDQDJZGLLJWJRKHPZGGFLCCSCZMCBLTBHBQJXQDSPDJZZGKGLFQYWBZYZJLTSTDHQHCTCBCHFLQMPWDSHYYTQWCNZZJTLBYMBPDYYYXSQKXWYYFLXXNCWCXYPMAELYKKJMZZZBRXYYQJFLJPFHHHYTZZXSGQQMHSPGDZQWBWPJHZJDYSCQWZKTXXSQLZYYMYSDZGRXCKKUJLWPYSYSCSYZLRMLQSYLJXBCXTLWDQZPCYCYKPPPNSXFYZJJRCEMHSZMSXLXGLRWGCSTLRSXBZGBZGZTCPLUJLSLYLYMTXMTZPALZXPXJTJWTCYYZLBLXBZLQMYLXPGHDSLSSDMXMBDZZSXWHAMLCZCPJMCNHJYSNSYGCHSKQMZZQDLLKABLWJXSFMOCDXJRRLYQZKJMYBYQLYHETFJZFRFKSRYXFJTWDSXXSYSQJYSLYXWJHSNLXYYXHBHAWHHJZXWMYLJCSSLKYDZTXBZSYFDXGXZJKHSXXYBSSXDPYNZWRPTQZCZENYGCXQFJYKJBZMLJCMQQXUOXSLYXXLYLLJDZBTYMHPFSTTQQWLHOKYBLZZALZXQLHZWRRQHLSTMYPYXJJXMQSJFNBXYXYJXXYQYLTHYLQYFMLKLJTMLLHSZWKZHLJMLHLJKLJSTLQXYLMBHHLNLZXQJHXCFXXLHYHJJGBYZZKBXSCQDJQDSUJZYYHZHHMGSXCSYMXFEBCQWWRBPYYJQTYZCYQYQQZYHMWFFHGZFRJFCDPXNTQYZPDYKHJLFRZXPPXZDBBGZQSTLGDGYLCQMLCHHMFYWLZYXKJLYPQHSYWMQQGQZMLZJNSQXJQSYJYCBEHSXFSZPXZWFLLBCYYJDYTDTHWZSFJMQQYJLMQXXLLDTTKHHYBFPWTYYSQQWNQWLGWDEBZWCMYGCULKJXTMXMYJSXHYBRWFYMWFRXYQMXYSZTZZTFYKMLDHQDXWYYNLCRYJBLPSXCXYWLSPRRJWXHQYPHTYDNXHHMMYWYTZCSQMTSSCCDALWZTCPQPYJLLQZYJSWXMZZMMYLMXCLMXCZMXMZSQTZPPQQBLPGXQZHFLJJHYTJSRXWZXSCCDLXTYJDCQJXSLQYCLZXLZZXMXQRJMHRHZJBHMFLJLMLCLQNLDXZLLLPYPSYJYSXCQQDCMQJZZXHNPNXZMEKMXHYKYQLXSXTXJYYHWDCWDZHQYYBGYBCYSCFGPSJNZDYZZJZXRZRQJJYMCANYRJTLDPPYZBSTJKXXZYPFDWFGZZRPYMTNGXZQBYXNBUFNQKRJQZMJEGRZGYCLKXZDSKKNSXKCLJSPJYYZLQQJYBZSSQLLLKJXTBKTYLCCDDBLSPPFYLGYDTZJYQGGKQTTFZXBDKTYYHYBBFYTYYBCLPDYTGDHRYRNJSPTCSNYJQHKLLLZSLYDXXWBCJQSPXBPJZJCJDZFFXXBRMLAZHCSNDLBJDSZBLPRZTSWSBXBCLLXXLZDJZSJPYLYXXYFTFFFBHJJXGBYXJPMMMPSSJZJMTLYZJXSWXTYLEDQPJMYGQZJGDJLQJWJQLLSJGJGYGMSCLJJXDTYGJQJQJCJZCJGDZZSXQGSJGGCXHQXSNQLZZBXHSGZXCXYLJXYXYYDFQQJHJFXDHCTXJYRXYSQTJXYEFYYSSYYJXNCYZXFXMSYSZXYYSCHSHXZZZGZZZGFJDLTYLNPZGYJYZYYQZPBXQBDZTZCZYXXYHHSQXSHDHGQHJHGYWSZTMZMLHYXGEBTYLZKQWYTJZRCLEKYSTDBCYKQQSAYXCJXWWGSBHJYZYDHCSJKQCXSWXFLTYNYZPZCCZJQTZWJQDZZZQZLJJXLSBHPYXXPSXSHHEZTXFPTLQYZZXHYTXNCFZYYHXGNXMYWXTZSJPTHHGYMXMXQZXTSBCZYJYXXTYYZYPCQLMMSZMJZZLLZXGXZAAJZYXJMZXWDXZSXZDZXLEYJJZQBHZWZZZQTZPSXZTDSXJJJZNYAZPHXYYSRNQDTHZHYYKYJHDZXZLSWCLYBZYECWCYCRYLCXNHZYDZYDYJDFRJJHTRSQTXYXJRJHOJYNXELXSFSFJZGHPZSXZSZDZCQZBYYKLSGSJHCZSHDGQGXYZGXCHXZJWYQWGYHKSSEQZZNDZFKWYSSTCLZSTSYMCDHJXXYWEYXCZAYDMPXMDSXYBSQMJMZJMTZQLPJYQZCGQHXJHHLXXHLHDLDJQCLDWBSXFZZYYSCHTYTYYBHECXHYKGJPXHHYZJFXHWHBDZFYZBCAPNPGNYDMSXHMMMMAMYNBYJTMPXYYMCTHJBZYFCGTYHWPHFTWZZEZSBZEGPFMTSKFTYCMHFLLHGPZJXZJGZJYXZSBBQSCZZLZCCSTPGXMJSFTCCZJZDJXCYBZLFCJSYZFGSZLYBCWZZBYZDZYPSWYJZXZBDSYUXLZZBZFYGCZXBZHZFTPBGZGEJBSTGKDMFHYZZJHZLLZZGJQZLSFDJSSCBZGPDLFZFZSZYZYZSYGCXSNXXCHCZXTZZLJFZGQSQYXZJQDCCZTQCDXZJYQJQCHXZTDLGSCXZSYQJQTZWLQDQZTQCHQQJZYEZZZPBWKDJFCJPZTYPQYQTTYNLMBDKTJZPQZQZZFPZSBNJLGYJDXJDZZKZGQKXDLPZJTCJDQBXDJQJSTCKNXBXZMSLYJCQMTJQWWCJQNJNLLLHJCWQTBZQYDZCZPZZDZYDDCYZZZCCJTTJFZDPRRTZTJDCQTQZDTJNPLZBCLLCTZSXKJZQZPZLBZRBTJDCXFCZDBCCJJLTQQPLDCGZDBBZJCQDCJWYNLLZYZCCDWLLXWZLXRXNTQQCZXKQLSGDFQTDDGLRLAJJTKUYMKQLLTZYTDYYCZGJWYXDXFRSKSTQTENQMRKQZHHQKDLDAZFKYPBGGPZREBZZYKZZSPEGJXGYKQZZZSLYSYYYZWFQZYLZZLZHWCHKYPQGNPGBLPLRRJYXCCSYYHSFZFYBZYYTGZXYLXCZWXXZJZBLFFLGSKHYJZEYJHLPLLLLCZGXDRZELRHGKLZZYHZLYQSZZJZQLJZFLNBHGWLCZCFJYSPYXZLZLXGCCPZBLLCYBBBBUBBCBPCRNNZCZYRBFSRLDCGQYYQXYGMQZWTZYTYJXYFWTEHZZJYWLCCNTZYJJZDEDPZDZTSYQJHDYMBJNYJZLXTSSTPHNDJXXBYXQTZQDDTJTDYYTGWSCSZQFLSHLGLBCZPHDLYZJYCKWTYTYLBNYTSDSYCCTYSZYYEBHEXHQDTWNYGYCLXTSZYSTQMYGZAZCCSZZDSLZCLZRQXYYELJSBYMXSXZTEMBBLLYYLLYTDQYSHYMRQWKFKBFXNXSBYCHXBWJYHTQBPBSBWDZYLKGZSKYHXQZJXHXJXGNLJKZLYYCDXLFYFGHLJGJYBXQLYBXQPQGZTZPLNCYPXDJYQYDYMRBESJYYHKXXSTMXRCZZYWXYQYBMCLLYZHQYZWQXDBXBZWZMSLPDMYSKFMZKLZCYQYCZLQXFZZYDQZPZYGYJYZMZXDZFYFYTTQTZHGSPCZMLCCYTZXJCYTJMKSLPZHYSNZLLYTPZCTZZCKTXDHXXTQCYFKSMQCCYYAZHTJPCYLZLYJBJXTPNYLJYYNRXSYLMMNXJSMYBCSYSYLZYLXJJQYLDZLPQBFZZBLFNDXQKCZFYWHGQMRDSXYCYTXNQQJZYYPFZXDYZFPRXEJDGYQBXRCNFYYQPGHYJDYZXGRHTKYLNWDZNTSMPKLBTHBPYSZBZTJZSZZJTYYXZPHSSZZBZCZPTQFZMYFLYPYBBJQXZMXXDJMTSYSKKBJZXHJCKLPSMKYJZCXTMLJYXRZZQSLXXQPYZXMKYXXXJCLJPRMYYGADYSKQLSNDHYZKQXZYZTCGHZTLMLWZYBWSYCTBHJHJFCWZTXWYTKZLXQSHLYJZJXTMPLPYCGLTBZZTLZJCYJGDTCLKLPLLQPJMZPAPXYZLKKTKDZCZZBNZDYDYQZJYJGMCTXLTGXSZLMLHBGLKFWNWZHDXUHLFMKYSLGXDTWWFRJEJZTZHYDXYKSHWFZCQSHKTMQQHTZHYMJDJSKHXZJZBZZXYMPAGQMSTPXLSKLZYNWRTSQLSZBPSPSGZWYHTLKSSSWHZZLYYTNXJGMJSZSUFWNLSOZTXGXLSAMMLBWLDSZYLAKQCQCTMYCFJBSLXCLZZCLXXKSBZQCLHJPSQPLSXXCKSLNHPSFQQYTXYJZLQLDXZQJZDYYDJNZPTUZDSKJFSLJHYLZSQZLBTXYDGTQFDBYAZXDZHZJNHHQBYKNXJJQCZMLLJZKSPLDYCLBBLXKLELXJLBQYCXJXGCNLCQPLZLZYJTZLJGYZDZPLTQCSXFDMNYCXGBTJDCZNBGBQYQJWGKFHTNPYQZQGBKPBBYZMTJDYTBLSQMPSXTBNPDXKLEMYYCJYNZCTLDYKZZXDDXHQSHDGMZSJYCCTAYRZLPYLTLKXSLZCGGEXCLFXLKJRTLQJAQZNCMBYDKKCXGLCZJZXJHPTDJJMZQYKQSECQZDSHHADMLZFMMZBGNTJNNLGBYJBRBTMLBYJDZXLCJLPLDLPCQDHLXZLYCBLCXZZJADJLNZMMSSSMYBHBSQKBHRSXXJMXSDZNZPXLGBRHWGGFCXGMSKLLTSJYYCQLTSKYWYYHYWXBXQYWPYWYKQLSQPTNTKHQCWDQKTWPXXHCPTHTWUMSSYHBWCRWXHJMKMZNGWTMLKFGHKJYLSYYCXWHYECLQHKQHTTQKHFZLDXQWYZYYDESBPKYRZPJFYYZJCEQDZZDLATZBBFJLLCXDLMJSSXEGYGSJQXCWBXSSZPDYZCXDNYXPPZYDLYJCZPLTXLSXYZYRXCYYYDYLWWNZSAHJSYQYHGYWWAXTJZDAXYSRLTDPSSYYFNEJDXYZHLXLLLZQZSJNYQYQQXYJGHZGZCYJCHZLYCDSHWSHJZYJXCLLNXZJJYYXNFXMWFPYLCYLLABWDDHWDXJMCXZTZPMLQZHSFHZYNZTLLDYWLSLXHYMMYLMBWWKYXYADTXYLLDJPYBPWUXJMWMLLSAFDLLYFLBHHHBQQLTZJCQJLDJTFFKMMMBYTHYGDCQRDDWRQJXNBYSNWZDBYYTBJHPYBYTTJXAAHGQDQTMYSTQXKBTZPKJLZRBEQQSSMJJBDJOTGTBXPGBKTLHQXJJJCTHXQDWJLWRFWQGWSHCKRYSWGFTGYGBXSDWDWRFHWYTJJXXXJYZYSLPYYYPAYXHYDQKXSHXYXGSKQHYWFDDDPPLCJLQQEEWXKSYYKDYPLTJTHKJLTCYYHHJTTPLTZZCDLTHQKZXQYSTEEYWYYZYXXYYSTTJKLLPZMCYHQGXYHSRMBXPLLNQYDQHXSXXWGDQBSHYLLPJJJTHYJKYPPTHYYKTYEZYENMDSHLCRPQFDGFXZPSFTLJXXJBSWYYSKSFLXLPPLBBBLBSFXFYZBSJSSYLPBBFFFFSSCJDSTZSXZRYYSYFFSYZYZBJTBCTSBSDHRTJJBYTCXYJEYLXCBNEBJDSYXYKGSJZBXBYTFZWGENYHHTHZHHXFWGCSTBGXKLSXYWMTMBYXJSTZSCDYQRCYTWXZFHMYMCXLZNSDJTTTXRYCFYJSBSDYERXJLJXBBDEYNJGHXGCKGSCYMBLXJMSZNSKGXFBNBPTHFJAAFXYXFPXMYPQDTZCXZZPXRSYWZDLYBBKTYQPQJPZYPZJZNJPZJLZZFYSBTTSLMPTZRTDXQSJEHBZYLZDHLJSQMLHTXTJECXSLZZSPKTLZKQQYFSYGYWPCPQFHQHYTQXZKRSGTTSQCZLPTXCDYYZXSQZSLXLZMYCPCQBZYXHBSXLZDLTCDXTYLZJYYZPZYZLTXJSJXHLPMYTXCQRBLZSSFJZZTNJYTXMYJHLHPPLCYXQJQQKZZSCPZKSWALQSBLCCZJSXGWWWYGYKTJBBZTDKHXHKGTGPBKQYSLPXPJCKBMLLXDZSTBKLGGQKQLSBKKTFXRMDKBFTPZFRTBBRFERQGXYJPZSSTLBZTPSZQZSJDHLJQLZBPMSMMSXLQQNHKNBLRDDNXXDHDDJCYYGYLXGZLXSYGMQQGKHBPMXYXLYTQWLWGCPBMQXCYZYDRJBHTDJYHQSHTMJSBYPLWHLZFFNYPMHXXHPLTBQPFBJWQDBYGPNZTPFZJGSDDTQSHZEAWZZYLLTYYBWJKXXGHLFKXDJTMSZSQYNZGGSWQSPHTLSSKMCLZXYSZQZXNCJDQGZDLFNYKLJCJLLZLMZZNHYDSSHTHZZLZZBBHQZWWYCRZHLYQQJBEYFXXXWHSRXWQHWPSLMSSKZTTYGYQQWRSLALHMJTQJSMXQBJJZJXZYZKXBYQXBJXSHZTSFJLXMXZXFGHKZSZGGYLCLSARJYHSLLLMZXELGLXYDJYTLFBHBPNLYZFBBHPTGJKWETZHKJJXZXXGLLJLSTGSHJJYQLQZFKCGNNDJSSZFDBCTWWSEQFHQJBSAQTGYPQLBXBMMYWXGSLZHGLZGQYFLZBYFZJFRYSFMBYZHQGFWZSYFYJJPHZBYYZFFWODGRLMFTWLBZGYCQXCDJYGZYYYYTYTYDWEGAZYHXJLZYYHLRMGRXXZCLHNELJJTJTPWJYBJJBXJJTJTEEKHWSLJPLPSFYZPQQBDLQJJTYYQLYZKDKSQJYYQZLDQTGJQYZJSUCMRYQTHTEJMFCTYHYPKMHYZWJDQFHYYXWSHCTXRLJHQXHCCYYYJLTKTTYTMXGTCJTZAYYOCZLYLBSZYWJYTSJYHBYSHFJLYGJXXTMZYYLTXXYPZLXYJZYZYYPNHMYMDYYLBLHLSYYQQLLNJJYMSOYQBZGDLYXYLCQYXTSZEGXHZGLHWBLJHEYXTWQMAKBPQCGYSHHEGQCMWYYWLJYJHYYZLLJJYLHZYHMGSLJLJXCJJYCLYCJPCPZJZJMMYLCQLNQLJQJSXYJMLSZLJQLYCMMHCFMMFPQQMFYLQMCFFQMMMMHMZNFHHJGTTHHKHSLNCHHYQDXTMMQDCYZYXYQMYQYLTDCYYYZAZZCYMZYDLZFFFMMYCQZWZZMABTBYZTDMNZZGGDFTYPCGQYTTSSFFWFDTZQSSYSTWXJHXYTSXXYLBYQHWWKXHZXWZNNZZJZJJQJCCCHYYXBZXZCYZTLLCQXYNJYCYYCYNZZQYYYEWYCZDCJYCCHYJLBTZYYCQWMPWPYMLGKDLDLGKQQBGYCHJXY";
				//此处收录了375个多音字,数据来自于http://www.51window.net/page/pinyin
				var oMultiDiff = {
					"19969": "DZ",
					"19975": "WM",
					"19988": "QJ",
					"20048": "YL",
					"20056": "SC",
					"20060": "NM",
					"20094": "QG",
					"20127": "QJ",
					"20167": "QC",
					"20193": "YG",
					"20250": "KH",
					"20256": "ZC",
					"20282": "SC",
					"20285": "QJG",
					"20291": "TD",
					"20314": "YD",
					"20340": "NE",
					"20375": "TD",
					"20389": "YJ",
					"20391": "CZ",
					"20415": "PB",
					"20446": "YS",
					"20447": "SQ",
					"20504": "TC",
					"20608": "KG",
					"20854": "QJ",
					"20857": "ZC",
					"20911": "PF",
					"20504": "TC",
					"20608": "KG",
					"20854": "QJ",
					"20857": "ZC",
					"20911": "PF",
					"20985": "AW",
					"21032": "PB",
					"21048": "XQ",
					"21049": "SC",
					"21089": "YS",
					"21119": "JC",
					"21242": "SB",
					"21273": "SC",
					"21305": "YP",
					"21306": "QO",
					"21330": "ZC",
					"21333": "SDC",
					"21345": "QK",
					"21378": "CA",
					"21397": "SC",
					"21414": "XS",
					"21442": "SC",
					"21477": "JG",
					"21480": "TD",
					"21484": "ZS",
					"21494": "YX",
					"21505": "YX",
					"21512": "HG",
					"21523": "XH",
					"21537": "PB",
					"21542": "PF",
					"21549": "KH",
					"21571": "E",
					"21574": "DA",
					"21588": "TD",
					"21589": "O",
					"21618": "ZC",
					"21621": "KHA",
					"21632": "ZJ",
					"21654": "KG",
					"21679": "LKG",
					"21683": "KH",
					"21710": "A",
					"21719": "YH",
					"21734": "WOE",
					"21769": "A",
					"21780": "WN",
					"21804": "XH",
					"21834": "A",
					"21899": "ZD",
					"21903": "RN",
					"21908": "WO",
					"21939": "ZC",
					"21956": "SA",
					"21964": "YA",
					"21970": "TD",
					"22003": "A",
					"22031": "JG",
					"22040": "XS",
					"22060": "ZC",
					"22066": "ZC",
					"22079": "MH",
					"22129": "XJ",
					"22179": "XA",
					"22237": "NJ",
					"22244": "TD",
					"22280": "JQ",
					"22300": "YH",
					"22313": "XW",
					"22331": "YQ",
					"22343": "YJ",
					"22351": "PH",
					"22395": "DC",
					"22412": "TD",
					"22484": "PB",
					"22500": "PB",
					"22534": "ZD",
					"22549": "DH",
					"22561": "PB",
					"22612": "TD",
					"22771": "KQ",
					"22831": "HB",
					"22841": "JG",
					"22855": "QJ",
					"22865": "XQ",
					"23013": "ML",
					"23081": "WM",
					"23487": "SX",
					"23558": "QJ",
					"23561": "YW",
					"23586": "YW",
					"23614": "YW",
					"23615": "SN",
					"23631": "PB",
					"23646": "ZS",
					"23663": "ZT",
					"23673": "YG",
					"23762": "TD",
					"23769": "ZS",
					"23780": "QJ",
					"23884": "QK",
					"24055": "XH",
					"24113": "DC",
					"24162": "ZC",
					"24191": "GA",
					"24273": "QJ",
					"24324": "NL",
					"24377": "TD",
					"24378": "QJ",
					"24439": "PF",
					"24554": "ZS",
					"24683": "TD",
					"24694": "WE",
					"24733": "LK",
					"24925": "TN",
					"25094": "ZG",
					"25100": "XQ",
					"25103": "XH",
					"25153": "PB",
					"25170": "PB",
					"25179": "KG",
					"25203": "PB",
					"25240": "ZS",
					"25282": "FB",
					"25303": "NA",
					"25324": "KG",
					"25341": "ZY",
					"25373": "WZ",
					"25375": "XJ",
					"25384": "A",
					"25457": "A",
					"25528": "SD",
					"25530": "SC",
					"25552": "TD",
					"25774": "ZC",
					"25874": "ZC",
					"26044": "YW",
					"26080": "WM",
					"26292": "PB",
					"26333": "PB",
					"26355": "ZY",
					"26366": "CZ",
					"26397": "ZC",
					"26399": "QJ",
					"26415": "ZS",
					"26451": "SB",
					"26526": "ZC",
					"26552": "JG",
					"26561": "TD",
					"26588": "JG",
					"26597": "CZ",
					"26629": "ZS",
					"26638": "YL",
					"26646": "XQ",
					"26653": "KG",
					"26657": "XJ",
					"26727": "HG",
					"26894": "ZC",
					"26937": "ZS",
					"26946": "ZC",
					"26999": "KJ",
					"27099": "KJ",
					"27449": "YQ",
					"27481": "XS",
					"27542": "ZS",
					"27663": "ZS",
					"27748": "TS",
					"27784": "SC",
					"27788": "ZD",
					"27795": "TD",
					"27812": "O",
					"27850": "PB",
					"27852": "MB",
					"27895": "SL",
					"27898": "PL",
					"27973": "QJ",
					"27981": "KH",
					"27986": "HX",
					"27994": "XJ",
					"28044": "YC",
					"28065": "WG",
					"28177": "SM",
					"28267": "QJ",
					"28291": "KH",
					"28337": "ZQ",
					"28463": "TL",
					"28548": "DC",
					"28601": "TD",
					"28689": "PB",
					"28805": "JG",
					"28820": "QG",
					"28846": "PB",
					"28952": "TD",
					"28975": "ZC",
					"29100": "A",
					"29325": "QJ",
					"29575": "SL",
					"29602": "FB",
					"30010": "TD",
					"30044": "CX",
					"30058": "PF",
					"30091": "YSP",
					"30111": "YN",
					"30229": "XJ",
					"30427": "SC",
					"30465": "SX",
					"30631": "YQ",
					"30655": "QJ",
					"30684": "QJG",
					"30707": "SD",
					"30729": "XH",
					"30796": "LG",
					"30917": "PB",
					"31074": "NM",
					"31085": "JZ",
					"31109": "SC",
					"31181": "ZC",
					"31192": "MLB",
					"31293": "JQ",
					"31400": "YX",
					"31584": "YJ",
					"31896": "ZN",
					"31909": "ZY",
					"31995": "XJ",
					"32321": "PF",
					"32327": "ZY",
					"32418": "HG",
					"32420": "XQ",
					"32421": "HG",
					"32438": "LG",
					"32473": "GJ",
					"32488": "TD",
					"32521": "QJ",
					"32527": "PB",
					"32562": "ZSQ",
					"32564": "JZ",
					"32735": "ZD",
					"32793": "PB",
					"33071": "PF",
					"33098": "XL",
					"33100": "YA",
					"33152": "PB",
					"33261": "CX",
					"33324": "BP",
					"33333": "TD",
					"33406": "YA",
					"33426": "WM",
					"33432": "PB",
					"33445": "JG",
					"33486": "ZN",
					"33493": "TS",
					"33507": "QJ",
					"33540": "QJ",
					"33544": "ZC",
					"33564": "XQ",
					"33617": "YT",
					"33632": "QJ",
					"33636": "XH",
					"33637": "YX",
					"33694": "WG",
					"33705": "PF",
					"33728": "YW",
					"33882": "SR",
					"34067": "WM",
					"34074": "YW",
					"34121": "QJ",
					"34255": "ZC",
					"34259": "XL",
					"34425": "JH",
					"34430": "XH",
					"34485": "KH",
					"34503": "YS",
					"34532": "HG",
					"34552": "XS",
					"34558": "YE",
					"34593": "ZL",
					"34660": "YQ",
					"34892": "XH",
					"34928": "SC",
					"34999": "QJ",
					"35048": "PB",
					"35059": "SC",
					"35098": "ZC",
					"35203": "TQ",
					"35265": "JX",
					"35299": "JX",
					"35782": "SZ",
					"35828": "YS",
					"35830": "E",
					"35843": "TD",
					"35895": "YG",
					"35977": "MH",
					"36158": "JG",
					"36228": "QJ",
					"36426": "XQ",
					"36466": "DC",
					"36710": "JC",
					"36711": "ZYG",
					"36767": "PB",
					"36866": "SK",
					"36951": "YW",
					"37034": "YX",
					"37063": "XH",
					"37218": "ZC",
					"37325": "ZC",
					"38063": "PB",
					"38079": "TD",
					"38085": "QY",
					"38107": "DC",
					"38116": "TD",
					"38123": "YD",
					"38224": "HG",
					"38241": "XTC",
					"38271": "ZC",
					"38415": "YE",
					"38426": "KH",
					"38461": "YD",
					"38463": "AE",
					"38466": "PB",
					"38477": "XJ",
					"38518": "YT",
					"38551": "WK",
					"38585": "ZC",
					"38704": "XS",
					"38739": "LJ",
					"38761": "GJ",
					"38808": "SQ",
					"39048": "JG",
					"39049": "XJ",
					"39052": "HG",
					"39076": "CZ",
					"39271": "XT",
					"39534": "TD",
					"39552": "TD",
					"39584": "PB",
					"39647": "SB",
					"39730": "LG",
					"39748": "TPB",
					"40109": "ZQ",
					"40479": "ND",
					"40516": "HG",
					"40536": "HG",
					"40583": "QJ",
					"40765": "YQ",
					"40784": "QJ",
					"40840": "YK",
					"40863": "QJG"
				};
				//参数,中文字符串
				//返回值:拼音首字母串数组
				return makePy(str)

				function makePy(str) {
					if (typeof(str) != "string")
						throw new Error(-1, "函数makePy需要字符串类型参数!");
					var arrResult = new Array(); //保存中间结果的数组
					for (var i = 0, len = str.length; i < len; i++) {
						//获得unicode码
						var ch = str.charAt(i);
						//检查该unicode码是否在处理范围之内,在则返回该码对映汉字的拼音首字母,不在则调用其它函数处理
						arrResult.push(checkCh(ch));
					}
					//处理arrResult,返回所有可能的拼音首字母串数组
					return mkRslt(arrResult);
				}

				function checkCh(ch) {
					var uni = ch.charCodeAt(0);
					//如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
					if (uni > 40869 || uni < 19968)
						return ch; //dealWithOthers(ch);
					//检查是否是多音字,是按多音字处理,不是就直接在strChineseFirstPY字符串中找对应的首字母
					return (oMultiDiff[uni] ? oMultiDiff[uni] : (strChineseFirstPY.charAt(uni - 19968)));
				}

				function mkRslt(arr) {
					var arrRslt = [""];
					for (var i = 0, len = arr.length; i < len; i++) {
						var str = arr[i];
						var strlen = str.length;
						if (strlen == 1) {
							for (var k = 0; k < arrRslt.length; k++) {
								arrRslt[k] += str;
							}
						} else {
							var tmpArr = arrRslt.slice(0);
							arrRslt = [];
							for (k = 0; k < strlen; k++) {
								//复制一个相同的arrRslt
								var tmp = tmpArr.slice(0);
								//把当前字符str[k]添加到每个元素末尾
								for (var j = 0; j < tmp.length; j++) {
									tmp[j] += str.charAt(k);
								}
								//把复制并修改后的数组连接到arrRslt上
								arrRslt = arrRslt.concat(tmp);
							}
						}
					}
					return arrRslt;
				}
				//两端去空格函数
				String.prototype.trim = function() {
					return this.replace(/(^\s*)|(\s*$)/g, "");
				}
			},
			getCurDate() {

				var date = new Date();
				var seperator1 = "/";
				var seperator2 = ":";
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
				// + " " + date.getHours() + seperator2 + date.getMinutes()
				// + seperator2 + date.getSeconds();
				return currentdate;

			},
			getTimeState() {
				// 获取当前时间
				let timeNow = new Date();
				// 获取当前小时
				let hours = timeNow.getHours();
				// 设置默认文字
				let state = ``;
				// 判断当前时间段
				if (hours >= 0 && hours <= 6) {
					state = `凌晨`;
				} else if (hours >= 0 && hours <= 10) {
					state = `早上`;
				} else if (hours > 10 && hours <= 14) {
					state = `中午`;
				} else if (hours > 14 && hours <= 18) {
					state = `下午`;
				} else if (hours > 18 && hours <= 24) {
					state = `晚上`;
				}
				return state;
			}
		},
		filters: {
			filterUrl(val) {

				var that = this

				if (val.indexOf('inchrouter') > -1) {
					// Vue.$Message.info('功能开发中')
					return '/appcenter'
				} else {
					return val
				}
			},
			filterNames(val) {
				//console.log(val, 'vallll')
				if (val.indexOf('inchrouter') > -1) {

					return false
				} else {
					return true
				}
			}
		},

	}
</script>

<style scoped>
	.beContent {
		flex: 1;
		padding-right: 20px;
		padding-top: 20px;
		overflow-y: scroll;
		padding-bottom: 50px;
		overflow-x: hidden;
    position:relative;
    z-index:10;
	}

	.conhead {
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #f5f5f5;
	}

	.conheadleft {
		width: 48%;
		min-width: 350px;
		display: flex;
		justify-content: flex-start;
		align-content: center;
		;
	}

	.conheadleft h4 {
		margin: 15px 0px 4px;
	}

	.conheadleft p {
		color: #bbb;
		font-size: 12px;
	}

	.conheadleft img {
		width: 120px;
		height: 70px;
		margin-right: 5px;
		margin-top: 6px;
	}

	.conheadRight {
		display: flex;
		justify-content: space-between;
		align-content: center
	}

	.conheadRight li {
		height: 76px;
		line-height:76px;
		list-style: none;
		display: flex;
		justify-content: space-between;
		align-content: center
	}
	.conheadRight li button{
		margin-top:30px;
	}
	.conheadRight li+li {
		margin-left: 60px;
		margin-right: 20px;
	}

	.conheadRight li p {
		margin: 12px auto 2px;
		font-size: 12px;
		color: #a4a6bd;
	}

	.conheadRight li h4 {
		font-size: 18px;
	}

	.conheadRight .icon {
		width: 30px;
		height: 30px;
		margin-right: 13px;
		margin-top: 15px;
	}

	.nav img.icon {
		width: 20px;
		height: 20px;
		position: relative;
		top: 5px;
		margin-right: 14px;
	}

	.dot {
		background: #4799f1;
		display: inline-block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		position: absolute;
		right: 20%;
		top: 21px;
		box-shadow: 0px 2px 5px 0px rgba(71, 153, 241, .5)
	}

	.becard {
		padding: 10px 20px 20px;
		border-radius: 8px;
		cursor: pointer;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.becard li {
		list-style: none;
		width: 20%;
		text-align: center;
		padding: 10px;
		padding-top: 20px;
		min-height: 190px;
		border-radius: 5px;
	}

	.becard li:hover {
		box-shadow: 0px 2px 10px 0px rgba(229, 229, 229, .9)
	}

	.becard li img {
		width: 50px;
		height: 50px;
	}

	.becard li p {
		font-size: 12px;
		color: #9aa5aa
	}

	.becard h5 {
		font-size: 15px;
		margin: 10px auto;
	}

	/* 	.conterConItem:first-of-type{margin-top:0px;} */
	.conterConItem h3 {
		padding: 20px;
		padding-bottom: 0px;
		font-size: 15px;
	}

/* 	.conterConItem h3 {
		margin: -85px 0 0;
		border-top: 85px solid #fff;
	} */

	.ordering {
		color: #00d186;
		background-color: #edfcf6;
		border-color: #00d186;
		position: absolute;
		top: -80px;
		left: 130px;
		font-size: 9px;
		font-weight: normal;
		padding: 2px 8px;
		border-radius: 6px;
		display: inline-block;
	}

	.orderFamily {
		position: relative;
	}
</style>
